import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ReactComponent as AiMagicIcon } from '../../../assets/icons/ai-magic.svg'
import {
    fetchCollectionMembersByProductId,
    fetchDesignDocs,
    fetchDesignInfoById,
    fetchExploreDesigns
} from '../../services/v3/DesignLab/DesignLab'
import { useDispatch } from 'react-redux'
import { closeLoader, openLoader } from '../../redux_toolkit/Loader'
import {
    capitalizeFirstAndLowercaseRest,
    convertNumberToUSFormat,
    isPickAndChooseBuyer
} from '../../helpers/Util'
import {
    addMixpanelTrackingEvent,
    fetchSetInfoById
} from '../../services/CommonService'
import { useGlobalState } from '../../redux_toolkit/V3/Common'
import {
    GET_FAVOURITE_COUNT,
    SELECT_DESIGN_FOR_FAVOURITE
} from '../../redux_toolkit/@types/thunk.types'
import AddToFavourite from './AddToFavourite'
import PackSetOrTag from './PackOrSetTag'

import DesignCardView from './DesignCardView'
import { DoFavouriteThunk } from '../../redux_toolkit/V3/DoFavourite/DoFavouriteThunk'
import { FavouriteThunks } from '../../redux_toolkit/Favourite/FavouriteThunks'
import { FilterActionTypes } from '../../redux_toolkit/V3/Filter'
import { ADD_FILTER_FIELDS } from '../../redux_toolkit/@types/action.types'
import FavoriteIcon from '../../common/FavoriteIcon'
import Image from '../../common/Image'
import BreadCrumb from './BreadCrumb'

const DesignView = () => {
    const [featureImageDocs, setFeatureImageDocs] = useState({})
    const [virtualTryOnDocResponse, setVirtualTryOnDocResponse] = useState(null)
    const [showFavourite, setShowFavourite] = useState(false)
    const [isViewAllClicked, setIsViewAllClicked] = useState(false)
    const [selectedZoom, setSelectedZoom] = useState(null)
    const [setStyleInfo, setSetStyleIfo] = useState(null)
    const [designInfo, setDesignInfo] = useState(null)
    const [designDocs, setDesignDocs] = useState([])
    const [designList, setDesignList] = useState([])
    const [totalSimilarItems, setTotalSimilarItems] = useState(null)
    const [filterOptions, setFilterOptions] = useState({})
    const [isSetProduct, setIsSetProduct] = useState(false)
    const [designId, setDesignId] = useState(null)
    const [loading, setLoading] = useState(false)
    const trackId = useGlobalState()?.productTrackId
    const dispatch = useDispatch()
    const { id } = useParams()
    const { pathname } = useLocation()
    const navigate = useNavigate()

    const fetchDesignInfos = async () => {
        const handleCategoryData = async (categoryId) => {
            if (!categoryId) return
            setLoading(true)
            const categoryData = await fetchExploreDesigns('?page=0&size=6', {
                categoryIdList: [categoryId]
            })
            setDesignList(categoryData.data)
            setTotalSimilarItems(categoryData?.totalElements)
            setLoading(false)
        }

        const handleProductDocs = async (productId) => {
            const productDocs = await fetchDesignDocs(productId)
            const defaultPresentationImages = productDocs?.productPresentationResponseList?.[0]?.documentResponse || []
            let defaultDocs = {
                front: {},
                back: {},
                fabric: {},
                embellishment: {}
            }
            if (defaultPresentationImages.length) {
                defaultPresentationImages.forEach((doc) => {
                    if (doc.docType === 'FRONT_IMAGE') {
                        defaultDocs.front = doc
                    } else if (doc.docType === 'BACK_IMAGE') {
                        defaultDocs.back = doc
                    } else if (doc.docType === 'FABRIC_IMAGE') {
                        defaultDocs.fabric = doc
                    } else if (doc.docType === 'EMBELLISHMENT') {
                        defaultDocs.embellishment = doc
                    }
                })
            }
            setDesignDocs(defaultDocs)
            setFeatureImageDocs(productDocs.featureImageDocResponse)
            setVirtualTryOnDocResponse(productDocs.virtualTryOnDocResponse)
        }

        try {
            const productInfo = await fetchDesignInfoById(designId || id)
            let categoryId

            if (productInfo?.isSet) {
                setIsSetProduct(true)
                const setData = await fetchSetInfoById(id)
                setSetStyleIfo(setData)

                const firstMemberProduct = setData?.setMemberProducts?.[0]
                if (firstMemberProduct) {
                    categoryId = isPickAndChooseBuyer()
                        ? firstMemberProduct?.categoryResponse?.id
                        : firstMemberProduct?.categoryId
                    await handleProductDocs(firstMemberProduct.id)
                    setDesignInfo(firstMemberProduct)
                }
                setDesignId(firstMemberProduct?.id)
            } else {
                categoryId = isPickAndChooseBuyer()
                    ? productInfo?.categoryResponse?.id
                    : productInfo?.categoryId
                await handleProductDocs(designId || id)
                setDesignInfo(productInfo)
            }

            await handleCategoryData(categoryId)
        } catch (e) {
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchDesignInfos()
    }, [id, designId])

    const handleZoomView = (imageType) => {
        if (selectedZoom === imageType) {
            setSelectedZoom(null)
        } else {
            setSelectedZoom(imageType)
        }
    }

    const isShowPresentationImage = () => {
        if (
            designDocs?.front?.docUrl &&
            designDocs?.back?.docUrl &&
            designDocs?.embellishment?.docUrl &&
            designDocs?.fabric?.docUrl
        ) {
            return true
        }
    }

    const getSetDesignDocuments = (memberList) => {
        let designDocuments = []
        memberList.forEach((member) => {
            let memberDocuments = member.designDocuments?.map((item) => ({
                ...item,
                productId: member.id
            }))
            designDocuments = [...designDocuments, ...memberDocuments]
        })
        return designDocuments
    }

    const renderSetStyles = () => {
        if (isSetProduct) {
            return (
                <div className='flex justify-between flex-wrap sm:flex-nowrap mb-6'>
                    <div className='set-image-tab'>
                        {getSetDesignDocuments(
                            setStyleInfo?.setMemberProducts || []
                        )?.map((item) => {
                            return (
                                <Image
                                    key={`set_style_image_${item.id}`}
                                    src={item.docUrl}
                                    alt='style'
                                    className={
                                        item.productId === designId
                                            ? 'active'
                                            : ''
                                    }
                                    onClick={() => setDesignId(item.productId)}
                                    isStatic={false}
                                />
                            )
                        })}
                    </div>
                </div>
            )
        }
    }

    const onViewAllClick = () => {
        let categoryId, categoryName
        if (isPickAndChooseBuyer()) {
            categoryId = designInfo?.categoryResponse?.id
            categoryName = designInfo?.categoryResponse?.name
        } else {
            categoryId = designInfo?.categoryId
            categoryName = designInfo?.category
        }
        let selectedCategory = {
            id: categoryId,
            label: categoryName,
            value: categoryName
        }
        setFilterOptions((prevOptions) => ({
            ...prevOptions,
            categoryList: selectedCategory
        }))
        setIsViewAllClicked(true)
        const requestBody = {
            category: designInfo?.category
        }
        addMixpanelTrackingEvent(requestBody, 'BUYER_VIEW_SIMILAR_CATEGORY')
    }

    const onViewAllFabricClick = () => {
        let baseMaterialId = designInfo?.mainFabricResponses[0]?.libraryId
        let fabricName = designInfo?.mainFabricResponses[0]?.name

        let selectedFabrics = {
            id: baseMaterialId,
            label: fabricName,
            value: fabricName
        }

        setFilterOptions((prevOptions) => ({
            ...prevOptions,
            mainFabricList: selectedFabrics
        }))
        setIsViewAllClicked(true)

        const requestBody = {
            productId: designInfo?.id,
            category: designInfo?.category,
            department: designInfo?.productGroup,
            fabricName: designInfo?.mainFabricResponses[0]?.name
        }
        addMixpanelTrackingEvent(requestBody, 'BUYER_VIEW_SIMILAR_FABRIC')
    }

    useEffect(() => {
        dispatch(FilterActionTypes[ADD_FILTER_FIELDS]({ data: filterOptions }))
        if (isViewAllClicked) {
            if (pathname !== '/design-lab') {
                navigate('/design-lab')
            }
        }
    }, [filterOptions])

    const toggleIsFavourite = async (bool, designInfo, isShowFav = true) => {
        if (!designInfo?.isSold) {
            setShowFavourite(true)
        } else {
            setShowFavourite(false)
        }
        await dispatch(
            DoFavouriteThunk[SELECT_DESIGN_FOR_FAVOURITE](designInfo, trackId)
        )
        await dispatch(FavouriteThunks[GET_FAVOURITE_COUNT]())
    }

    const renderSimilarDesigns = () => {
        return designList?.map((item, i) => {
            return (
                <React.Fragment key={`single_item_${i}`}>
                    <DesignCardView
                        designInfo={item}
                        triggerIsFavourite={toggleIsFavourite}
                    />
                </React.Fragment>
            )
        })
    }

    return (
        <>
            <div className='design-view-container style-zoom-modal'>
                <div className='pt-4'>
                    <BreadCrumb />
                </div>
                <div className='common-popup'>
                    <div className='common-popup-header d-flex justify-content-between'>
                        <div className='popup-tilte'>
                            <h3 className='semibold-16 mb-0'>
                                <span>
                                    {designInfo?.productGroup}
                                    {designInfo?.productGroup && ','}&nbsp;
                                </span>
                                {capitalizeFirstAndLowercaseRest(
                                    setStyleInfo?.isSet
                                        ? setStyleInfo?.name
                                        : designInfo?.name
                                )}
                                &nbsp;&nbsp;
                                {!setStyleInfo?.isSet && designInfo?.isPack && (
                                    <PackSetOrTag tagName='Pack' />
                                )}
                                {setStyleInfo?.isSet && (
                                    <PackSetOrTag tagName='Set' />
                                )}
                            </h3>
                        </div>
                        <div className='d-flex gap-2 items-center'>
                            <div className='actions-buttons mt-2 xl:mt-8'>
                                <button
                                    className='button secondary'
                                    onClick={() =>
                                        toggleIsFavourite(true, designInfo)
                                    }
                                >
                                    <span className='mr-2'>Favourite</span>
                                    <FavoriteIcon isLiked={designInfo?.liked} />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='common-popup-body !py-0 sm:!pb-4 scroll-x-label'>
                        <div className='style-all-information'>
                            <div className='info-items mb-6'>
                                <div className='single-info flex items-center mb-2'>
                                    <p className='regular-12 gray_300'>
                                        Design no
                                    </p>
                                    {designInfo?.referenceNumber && (
                                        <h3 className='regular-14 weight-700'>
                                            {designInfo?.referenceNumber}
                                        </h3>
                                    )}
                                </div>
                                <div className='single-info flex items-center mb-2'>
                                    <p className='regular-12 gray_300'>
                                        Fabric
                                    </p>

                                    <div className='items-center sm:!flex'>
                                        <h3 className='regular-14 weight-700'>
                                            {capitalizeFirstAndLowercaseRest(
                                                designInfo?.fabricName
                                            )}
                                        </h3>
                                        {designInfo?.mainFabricResponses && (
                                            <button
                                                className='button link sm:ml-4 fabric-view-btn'
                                                onClick={() => {
                                                    onViewAllFabricClick()
                                                }}
                                            >
                                                <span className='regular-12 weight-400'>
                                                    View Similar Fabric
                                                </span>
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {(designInfo?.buyerApprovedPrice ||
                                    (designInfo?.pickAndChooseOfferPrice &&
                                        isPickAndChooseBuyer())) && (
                                    <div className='single-info flex mb-2'>
                                        <p className='regular-12 gray_300'>
                                            Price
                                        </p>
                                        <h3 className='regular-14 weight-700'>
                                            {designInfo?.buyerApprovedPrice ? (
                                                <>
                                                    $
                                                    {convertNumberToUSFormat(
                                                        designInfo?.buyerApprovedPrice
                                                    )}
                                                </>
                                            ) : (
                                                designInfo?.pickAndChooseOfferPrice &&
                                                isPickAndChooseBuyer() && (
                                                    <>
                                                        $
                                                        {designInfo?.pickAndChooseOfferPrice?.toFixed(
                                                            2
                                                        )}
                                                    </>
                                                )
                                            )}
                                        </h3>
                                        <ul className='gap-2 price-info'>
                                            <li className='gray_200'>
                                                <span className='w-1 h-1 bg-[#999A9D] rounded-full mr-2 relative top-[-2px]'></span>
                                                Price may vary
                                            </li>
                                            <li className='gray_200'>
                                                <span className='w-1 h-1 bg-[#999A9D] rounded-full mr-2 relative top-[-2px]'></span>
                                                Applicable for MOQ 1000.
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='d-flex flex-wrap md:!flex-nowrap gap-[12px]'>
                            <div className='all-images order-2 sm:!order-1'>
                                {isShowPresentationImage() && (
                                    <div
                                        className={`style-and-fabric ${
                                            selectedZoom !== null
                                                ? 'zoom-view'
                                                : ''
                                        }`}
                                    >
                                        {designDocs?.front?.docUrl &&
                                            (selectedZoom === null ||
                                                selectedZoom === 'FRONT') && (
                                                <div
                                                    className='single-image front'
                                                    onClick={() =>
                                                        handleZoomView('FRONT')
                                                    }
                                                >
                                                    <Image
                                                        src={
                                                            designDocs?.front
                                                                ?.docUrl
                                                        }
                                                        isStatic={false}
                                                    />
                                                </div>
                                            )}
                                        {designDocs?.back?.docUrl &&
                                            (selectedZoom === null ||
                                                selectedZoom === 'BACK') && (
                                                <div
                                                    className='single-image back'
                                                    onClick={() =>
                                                        handleZoomView('BACK')
                                                    }
                                                >
                                                    <Image
                                                        src={
                                                            designDocs?.back
                                                                ?.docUrl
                                                        }
                                                        isStatic={false}
                                                    />
                                                </div>
                                            )}
                                        {designDocs?.fabric?.docUrl &&
                                            (selectedZoom === null ||
                                                selectedZoom === 'FABRIC') && (
                                                <div
                                                    className='single-image fabric'
                                                    onClick={() =>
                                                        handleZoomView('FABRIC')
                                                    }
                                                >
                                                    <Image
                                                        src={
                                                            designDocs?.fabric
                                                                ?.docUrl
                                                        }
                                                        isStatic={false}
                                                    />
                                                </div>
                                            )}
                                        {designDocs?.embellishment?.docUrl &&
                                            (selectedZoom === null ||
                                                selectedZoom ===
                                                    'EMBELLISHMENT') && (
                                                <div
                                                    className='single-image fabric'
                                                    onClick={() =>
                                                        handleZoomView(
                                                            'EMBELLISHMENT'
                                                        )
                                                    }
                                                >
                                                    <Image
                                                        src={
                                                            designDocs
                                                                ?.embellishment
                                                                ?.docUrl
                                                        }
                                                        isStatic={false}
                                                    />
                                                </div>
                                            )}
                                    </div>
                                )}
                                {!isShowPresentationImage() &&
                                    featureImageDocs?.docUrl && (
                                        <div className='style-and-fabric zoom-view'>
                                            <div className='single-image'>
                                                <Image
                                                    src={
                                                        featureImageDocs?.docUrl
                                                    }
                                                    isStatic={false}
                                                />
                                            </div>
                                        </div>
                                    )}
                            </div>
                            {virtualTryOnDocResponse?.docUrl && (
                                <div className='all-content order-1 sm:!order-2'>
                                    <div className='ai-model-img'>
                                        <Image
                                            src={
                                                virtualTryOnDocResponse?.docUrl ||
                                                '/images/default_product.svg'
                                            }
                                            alt='ai-model-img'
                                            isStatic={
                                                !virtualTryOnDocResponse?.docUrl
                                            }
                                        />
                                        <div className='ai-tag d-flex items-center justify-content-center'>
                                            <AiMagicIcon
                                                width={24}
                                                height={24}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='mt-3'>{renderSetStyles()}</div>

                        <div className='similar-category-designs mt-10'>
                            {totalSimilarItems > 0 && (
                                <div className='flex justify-between mb-4'>
                                    <h3 className='semibold-18'>
                                        Similar Category Designs (
                                        {totalSimilarItems})
                                    </h3>
                                    <button
                                        className='button link'
                                        onClick={() => {
                                            onViewAllClick()
                                        }}
                                    >
                                        View All
                                    </button>
                                </div>
                            )}
                            {!loading && designList?.length > 0 && (
                                <div className='design-list-container image-view 2xl:grid-cols-6'>
                                    {renderSimilarDesigns()}
                                </div>
                            )}
                            {loading && (
                                <div className='d-flex justify-content-center mt-5 pt-5'>
                                    <div className='round-loader'></div>
                                </div>
                            )}
                            {!loading && designList?.length === 0 && (
                                <p className='text-center text-base weight-500 py-16'>
                                    No similar design found!
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <AddToFavourite
                isVisible={showFavourite}
                setIsVisible={setShowFavourite}
            />
        </>
    )
}

export default DesignView
